import { Component, OnInit, ViewContainerRef, ComponentFactoryResolver, ViewChild, OnChanges, SimpleChange, ElementRef, ComponentRef, OnDestroy, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MyProfileComponent } from '../myprofile/myprofile.component';
import { IndicateComponent } from '../indicate/indicate.component';
import { AuthenticatorComponent } from 'src/app/core/auth/components/authenticator/authenticator.component';
import { SignUpComponent } from 'src/app/core/auth/components/sign-up/sign-up.component';
import { AdvertiseFormComponent } from 'src/app/modules/home/components/advertise/advertise.form.component';
import { TermsComponent } from '../terms/terms.component';
import { AvailableComponent } from 'src/app/modules/builder/components/available/available.component';
import { SettingsComponent } from 'src/app/modules/builder/components/settings/settings.component';
import { SharesComponent } from 'src/app/modules/builder/components/shares/shares.component';
import { RequestsComponent } from 'src/app/modules/builder/components/requests/requests.component';
import { FollowersComponent } from 'src/app/modules/builder/components/followers/followers.component';
import { ActivitiesComponent } from 'src/app/modules/builder/components/activities/activities.component';
import { GeneralService } from '../../services/general.service';
import { ViewService } from 'src/app/modules/realtor/components/view/view.service';
import { ViewComponent } from 'src/app/modules/realtor/components/view/view.component';
import { AccessManagerComponent } from 'src/app/modules/admin/components/person/accessManager/accessManager.component';
import { HeatmapComponent } from '../heatmap/heatmap.component';
import { UnitAmountComponent } from 'src/app/modules/builder/components/unit-amount/unit-amount.component';
import { UsersManagerComponent } from '../usersManager/usersManager.component';
import { RealestateComponent } from '../realestate/realestate.component';
import { FeedbackComponent } from '../feedback/feedback.component';
import { ProfileComponent } from '../profile/profile.component';
import { DialogPreferencesComponent } from '../dialog-preferences/dialog-preferences.component';
import { DialogAuthorizationListComponent } from '../dialog-authorization-list/dialog-authorization-list.component';
import { DialogRequestListComponent } from '../dialog-request-list/dialog-request-list.component';
import { CanvaComponent } from '../canva-component/canva.component';
import { PostsComponent } from '../posts/posts.component'; 
import { GalleryComponent } from '../gallery/gallery.component';
import { PersonComponent } from '../person/person.component';

declare var $: any;

@Component({
  selector: 'modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})

export class ModalComponent implements OnInit, OnChanges, OnDestroy {

  @ViewChild("container", { static:true, read: ViewContainerRef }) container:ViewContainerRef;

  modal : any = {};

  private id = null;
  private modalId = null;
  private attrs:any = {};
  private params:any = {};

  private elClasslist = null;
  private componentRef:ComponentRef<any>;

  loading = false;
  error = false;
  type:any;

  component:any;
 
  typeTitle = {
    ad : 'Anúncio',
    person : 'Perfil'
  }

  errorImageUrl = '';

  private callbackSubscribe:Subscription;

  private components = {
    'ProfileComponent' : ProfileComponent,
    'MyProfileComponent' : MyProfileComponent,
    'DialogPreferencesComponent' : DialogPreferencesComponent,
    'DialogAuthorizationListComponent' : DialogAuthorizationListComponent,
    'DialogRequestListComponent' : DialogRequestListComponent,
    'IndicateComponent' : IndicateComponent,
    'RealestateComponent' : RealestateComponent,
    'FeedbackComponent' : FeedbackComponent,
    'AuthenticatorComponent' : AuthenticatorComponent,
    'SignUpComponent' : SignUpComponent,
    'AdvertiseFormComponent' : AdvertiseFormComponent,
    'ViewComponent' : ViewComponent,
    'TermsComponent' : TermsComponent,
    'AvailableComponent' : AvailableComponent,
    'UnitAmountComponent' : UnitAmountComponent,
    'HeatmapComponent' : HeatmapComponent,
    'SettingsComponent' : SettingsComponent,
    'SharesComponent' : SharesComponent,
    'RequestsComponent' : RequestsComponent,
    'FollowersComponent' : FollowersComponent,
    'ActivitiesComponent' : ActivitiesComponent,
    'AccessManagerComponent' : AccessManagerComponent,
    'UsersManagerComponent' : UsersManagerComponent,
    'PostsComponent' : PostsComponent,
    'GalleryComponent' : GalleryComponent,
    'CanvaComponent' : CanvaComponent,
    'PersonComponent' : PersonComponent
  };

  constructor(
    private gs: GeneralService,
    private elRef:ElementRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private vs : ViewService,
    public dialogRef: MatDialogRef<any>,    
    @Inject(MAT_DIALOG_DATA) public dialogData
  ) {      

      if(dialogData?.component)
        this.component = dialogData?.component;

      if(dialogData?.id)
        this.id = dialogData?.id;

      if(dialogData?.modalId)
        this.modalId = dialogData?.modalId;
      
      if(dialogData?.type)
        this.type = dialogData?.type;

      if(dialogData?.params)
        this.params = dialogData?.params;
        
      this.errorImageUrl = this.getErrorImageUrl();
  }


  ngOnInit() {
    this.loadComponent(this.component);
  }

  ngOnDestroy(){
    this.callbackSubscribe?.unsubscribe();
  }

  ngOnChanges(changes: { [key: string]: SimpleChange }) {
    this.attrs = changes.data.currentValue;
  }

  i = 0;

  async loadComponent(component){
    if(!component)
      return;
  
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.getComponent(component));

    this.container.clear();
    this.componentRef = this.container.createComponent(componentFactory);
    let instance = (<any>this.componentRef.instance);
    instance.id = this.id;
    if(instance?.modalId)
      instance.modalId = this.modalId;

    instance.type = this.type;
    instance.params = this.params;

    if(typeof instance.closeDialog == 'function'){
      this.dialogRef.disableClose = true;
      this.dialogRef.backdropClick().subscribe(_ => {
        instance.closeDialog();
      });
    }

    instance.dialogRef = this.dialogRef;
  }

  modalClose(event){
    if(typeof (<any>this.componentRef.instance).closeDialog == 'function')
      (<any>this.componentRef.instance).closeDialog(event);
    else
      this.dialogRef.close();
  }

  getComponent(type){
    return this.components[type];
  }

  getErrorImageUrl() {
    return this.gs.buildImagemUrl('icon-clear.png');
  }



}